// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 818) return "static/chunks/818-ed32d4ff0b03fd84.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"c9191991c92a37ea","298":"3c17f9a45cf5b456","340":"5a47d46a7d4ceff1","367":"f10033cdcde02074","639":"662b2e7c337118a6","748":"bf7aff0dee7a9423"}[chunkId] + ".js";
};